import { useState, useEffect } from 'react';
import BackToDashboard from '../components/BackToDashboard';
import { adminSettings } from '../api/client';

export default function AdminSettings() {
  const [listingLimit, setListingLimit] = useState<number>(20);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState<'saved' | 'error' | null>(null);

  useEffect(() => {
    adminSettings
      .get()
      .then((r) => setListingLimit(r.listingLimit ?? 20))
      .catch(() => setListingLimit(20))
      .finally(() => setLoading(false));
  }, []);

  const handleSaveLimit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setMessage(null);
    try {
      await adminSettings.updateListingLimit(listingLimit);
      setMessage('saved');
    } catch {
      setMessage('error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="dash-page">
      <BackToDashboard />
      <header className="dash-page-header">
        <h1 className="dash-page-title">Settings</h1>
        <p className="dash-page-desc">
          Control app-wide settings. Customer ad limit can be set to 0 for unlimited.
        </p>
      </header>

      {loading ? (
        <p style={{ color: '#6b7280' }}>Loading…</p>
      ) : (
        <section className="dash-card">
          <div className="dash-card-header">
            <h2 className="dash-card-title">Customer ad limit</h2>
          </div>
          <div className="dash-card-body">
            <p style={{ fontSize: '0.9375rem', color: '#6b7280', marginBottom: '1rem' }}>
              Maximum number of ads per customer (per org). Set to 0 for unlimited. Default: 20.
            </p>
            <form onSubmit={handleSaveLimit} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
              <input
                type="number"
                min={0}
                max={999}
                value={listingLimit}
                onChange={(e) => setListingLimit(Math.max(0, parseInt(e.target.value, 10) || 0))}
                className="dash-form-input"
                style={{ width: 100 }}
              />
              <button type="submit" disabled={saving} className="dash-btn dash-btn--primary">
                {saving ? 'Saving…' : 'Save'}
              </button>
              {message === 'saved' && <span style={{ color: '#059669', fontSize: '0.9375rem', fontWeight: 500 }}>Saved.</span>}
              {message === 'error' && <span style={{ color: '#b91c1c', fontSize: '0.9375rem' }}>Failed to save.</span>}
            </form>
          </div>
        </section>
      )}
    </div>
  );
}
